/**
 * Formats a number with thousand separators
 * @param {number} num - The number to format
 * @returns {string} Formatted number string
 */
export const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    return num.toLocaleString('en-US');
};

/**
 * Formats a number to a compact format (e.g., 1.2K, 5.3M)
 * @param {number} num - The number to format
 * @returns {string} Compact formatted number string
 */
export const formatCompactNumber = (num) => {
    if (num === null || num === undefined) return '0';

    const absNum = Math.abs(num);

    if (absNum >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
    } else if (absNum >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
    }

    return num.toString();
};